package com.accelarge.indeffi.webfr.components.forms.inputs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.BasePath.Companion.value
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.components.widgets.form.Description2Style
import org.example.site_web.components.widgets.form.InputEditShowOnlyStyle
import org.example.site_web.components.widgets.form.InputEditStyle
import org.example.site_web.components.widgets.form.Label2Style
import org.example.site_web.components.widgets.form.TextAreaEditStyle
import org.example.site_web.components.widgets.form.TextAreaShowOnlyFieldStyle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.pattern
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.rows
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea


@Composable
fun MyTextInputGeneric(inputText: MutableState<String>,
                       editableState: MutableState<Boolean>,
                       id: String,
                       label: String = "Generic text input",
                       placeholder:String = "Enter Text",
                       validationRegExp:String = "",
                       validationInfoText: String = "Caractère non attendu.",
                       type: InputType<String> = InputType.Text) {

    val isValid = remember { mutableStateOf(true) }
    Label(
        forId = id, attrs = Label2Style
            .toModifier()
            .fillMaxWidth()
            .toAttrs()
    ) {
        Column() {
            Span(
                Description2Style
                    .toModifier()
                    .toAttrs()
            ) {
                Span(){
                    Text(value = "$label")
                    if(!isValid.value)
                    {
                        Span(Modifier
                            .color(Colors.Red)
                            .fontWeight(FontWeight.Bold)
                            .toAttrs()){
                            Text("-$validationInfoText")
                        }
                    }
                }
            }
            if(editableState.value) {
                Input(
                    type = type,
                    InputEditStyle.toModifier()
                        .toAttrs {
                            pattern(validationRegExp)
                            placeholder(placeholder)
                            id(id)
                            name(id)
                            attr("autocomplete", "off")
                            value(inputText.value)
                            onInput { evt ->
                                console.log("There")
                                console.log(evt)
                                inputText.value = evt.value
                                isValid.value = evt.target.checkValidity()
                            }
                            onInvalid {evt->
                                console.log("Invalide ${isValid.value}")
                            }
                        })}
            else{
                Input(
                    type = type,
                    InputEditShowOnlyStyle.toModifier()
                        .toAttrs {
                            attr("disabled","true")
                            id(id)
                            name(id)
                            attr("autocomplete", "off")
                            value(inputText.value)
                            onInput { evt -> inputText.value = evt.value }
                        })
            }
        }
    }
}

@Composable
fun MyTextInputPhone(inputText: MutableState<String>,
                     editableState: MutableState<Boolean>,
                     id: String,
                     label: String = "Phone number",
                     placeholder:String = "Ex: 0236457485",
                     validationRegExp:String = "0[1-9][0-9]{8}",
                     validationInfoText: String = "Format non attendu."){
    MyTextInputGeneric(inputText, editableState, id, label,placeholder, validationRegExp, validationInfoText,type= InputType.Tel)
}

@Composable
fun MyTextInputEmail(inputText: MutableState<String>,
                     editableState: MutableState<Boolean>,
                     id: String,
                     label: String = "EMail",
                     placeholder:String = "ex: hello-accelargeinnov@mymail.com",
                     validationRegExp:String = "^[^\\s@]+@([^\\s@.,]+\\.)+[^\\s@.,]{2,}\$",
                     validationInfoText: String = "Format non attendu."){
    MyTextInputGeneric(inputText, editableState, id, label,placeholder, validationRegExp, validationInfoText,type= InputType.Email)
}

@Composable
fun MyTextAreaInput(inputText: MutableState<String>,
                    editableState: MutableState<Boolean>,
                    id: String,
                    label: String = "Generic text input",
                    placeholder:String = "Enter Text",
                    validationRegExp:String = "",
                    validationInfoText: String = "Caractère non attendu.",
                    type: InputType<String> = InputType.Text) {

    val isValid = remember { mutableStateOf(true) }
    Label(
        forId = id, attrs = Label2Style
            .toModifier()
            .fillMaxWidth()
            .toAttrs()
    ) {
        Column(Modifier.fillMaxWidth()) {
            Span(
                Description2Style
                    .toModifier()
                    .toAttrs()
            ) {
                Text(value = "$label${if(isValid.value) "" else "-$validationInfoText"}")
            }
            if(editableState.value) {
                TextArea(
                    value=inputText.value,
                    TextAreaEditStyle.toModifier()
                        .toAttrs {
                            rows(4)
                            placeholder(placeholder)
                            id(id)
                            name(id)
                            attr("autocomplete", "off")
                            value(inputText.value)
                            onInput { evt ->
                                console.log("There")
                                console.log(evt)
                                inputText.value = evt.value
                                isValid.value = evt.target.checkValidity()
                            }
                        })
            }
            else{
                TextArea(
                    value=inputText.value,
                    TextAreaShowOnlyFieldStyle.toModifier()
                        .toAttrs {
                            rows(4)
                            attr("disabled","true")
                            id(id)
                            name(id)
                            attr("autocomplete", "off")
                            value(inputText.value)
                            onInput { evt -> inputText.value = evt.value }
                        })
            }
        }
    }
}